import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";

export default function Terms() {
  return (
    <div className="min-h-screen px-5 py-10 max-w-2xl mx-auto" data-testid="terms-page">
      <Link to="/" className="chip" data-testid="terms-back"><ArrowLeft size={14} /> Back</Link>
      <div className="flex justify-center mt-6"><BrandLogo size={88} /></div>
      <h1 className="font-display text-4xl sm:text-5xl text-sage-dark text-center mt-4">Bloom Keeper Terms of Use</h1>
      <p className="text-center text-ink-soft mt-1 font-display italic">Last updated: June 2026</p>

      <div className="h-card p-6 sm:p-8 mt-8 space-y-5 text-ink leading-relaxed">
        <p>
          Welcome to Bloom Keeper, a digital gardening companion provided by Heritage Dahlias NZ Limited
          ("Heritage Dahlias", "we", "our", or "us"). By accessing or using Bloom Keeper, you agree to these Terms of Use.
        </p>

        {SECTIONS.map((s, i) => (
          <section key={s.title}>
            <h2 className="font-display text-2xl text-sage-dark">{i + 1}. {s.title}</h2>
            {s.body.map((p, j) =>
              Array.isArray(p)
                ? (
                  <ul key={j} className="mt-2 list-disc list-inside space-y-1 text-ink-soft">
                    {p.map((b, k) => <li key={k}>{b}</li>)}
                  </ul>
                )
                : <p key={j} className="mt-2 text-ink">{p}</p>
            )}
          </section>
        ))}

        <section>
          <h2 className="font-display text-2xl text-sage-dark">10. Contact</h2>
          <p className="mt-2">For questions regarding these Terms of Use, please contact:</p>
          <p className="mt-2 font-display text-lg text-sage-dark">Heritage Dahlias NZ Limited</p>
          <a href="mailto:Heritagedahliasnz@gmail.com" className="underline text-sage-dark">Heritagedahliasnz@gmail.com</a>
        </section>
      </div>
    </div>
  );
}

const SECTIONS = [
  { title: "Purpose of Bloom Keeper", body: [
      "Bloom Keeper is designed to help users record, organise, and manage gardening information, including but not limited to plants, seeds, tubers, cuttings, garden beds, notes, observations, and photographs.",
      "Bloom Keeper is provided as a gardening record-keeping tool only.",
  ]},
  { title: "User Accounts", body: [
      "To use certain features, users may be required to create an account and provide basic information including a name and email address.",
      "You are responsible for maintaining the accuracy of your account information.",
      "You are responsible for any activity conducted through your account.",
  ]},
  { title: "User Content", body: [
      "You retain ownership of all information, photographs, notes, and records you enter into Bloom Keeper.",
      "By submitting content, you grant Heritage Dahlias a limited licence to store, process, and display that content solely for the purpose of operating Bloom Keeper.",
      "We do not claim ownership of your gardening records.",
  ]},
  { title: "Acceptable Use", body: [
      "Users must not:",
      [
        "Upload unlawful, harmful, abusive, or offensive content.",
        "Attempt to interfere with the operation of Bloom Keeper.",
        "Access accounts belonging to other users.",
        "Upload malicious software or harmful code.",
        "Use the service for unlawful purposes.",
      ],
      "We reserve the right to suspend or terminate accounts that violate these terms.",
  ]},
  { title: "Availability", body: [
      "We aim to keep Bloom Keeper available and functioning properly. However, we do not guarantee uninterrupted access and may modify, update, suspend, or discontinue features at any time.",
  ]},
  { title: "Data Loss", body: [
      "While reasonable measures are taken to protect user information, users are responsible for maintaining their own backups of important records.",
      "Heritage Dahlias is not liable for loss of user-generated content arising from technical failures, outages, or unforeseen circumstances.",
  ]},
  { title: "Intellectual Property", body: [
      "The Bloom Keeper name, branding, logos, designs, software, and associated content remain the property of Heritage Dahlias NZ Limited.",
      "Users may not copy, reproduce, modify, distribute, or resell any part of Bloom Keeper without written permission.",
  ]},
  { title: "Limitation of Liability", body: [
      'Bloom Keeper is provided on an "as available" basis.',
      "To the maximum extent permitted by law, Heritage Dahlias shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from the use of Bloom Keeper.",
  ]},
  { title: "Changes to These Terms", body: [
      "We may update these Terms of Use from time to time. Continued use of Bloom Keeper after changes are published constitutes acceptance of the revised terms.",
  ]},
];
